// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { HtmlContentDocument } from "./documents/html-content-document";
import { ItemEnvelope } from "./base/item-envelope";

export class HtmlContentEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "HtmlContent");
		if (jsonEnvelope) {
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public override Document: HtmlContentDocument = new HtmlContentDocument();
	public override get ItemId(): number { return this.Document.Item.HtmlContentId; }
	public override get ItemName(): string { return this.Document.Item.Name; }
}